var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          class: { "mobile-custom-box": _vm.isMobile },
          attrs: {
            title: _vm.$t("addEmail"),
            visible: _vm.dialogShow,
            modal: false,
            "modal-append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              class: { "mobile-form": _vm.isMobile },
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  key: "type",
                  staticClass: "lodingItem",
                  attrs: { prop: "type", label: _vm.$t("sendType") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: {
                        disabled: _vm.isshot,
                        placeholder: _vm.$t("pleaseSelectSendType")
                      },
                      on: {
                        change: function($event) {
                          return _vm.clearData(false, false)
                        }
                      },
                      model: {
                        value: _vm.paramsData.type,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "type", $$v)
                        },
                        expression: "paramsData.type"
                      }
                    },
                    _vm._l(_vm.whetherNot, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.paramsData.type == "list_role"
                ? _c(
                    "el-form-item",
                    {
                      key: "role_ids",
                      staticClass: "lodingItem",
                      attrs: { prop: "role_ids", label: _vm.$t("roleId") }
                    },
                    [
                      _c("el-input", {
                        staticClass: "operationFrame-entity",
                        attrs: {
                          disabled: _vm.isshot,
                          placeholder: _vm.$t("roleIdPlaceholder")
                        },
                        model: {
                          value: _vm.paramsData.role_ids,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "role_ids", $$v)
                          },
                          expression: "paramsData.role_ids"
                        }
                      }),
                      _c("uploadImagetow", {
                        ref: "uploadImagetow",
                        staticStyle: { "margin-left": "20px" },
                        attrs: {
                          fileType: ".txt",
                          filesname: "txt",
                          Url: "/hjhd-gm/upload_txt",
                          title: _vm.$t("uploadTxt"),
                          disabled: _vm.isshot
                        },
                        on: {
                          change: function($event) {
                            return _vm.fileUp($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  key: "server_ids",
                  staticClass: "lodingItem",
                  attrs: { prop: "server_ids", label: _vm.$t("serverMultiple") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: {
                        disabled: _vm.isshot,
                        "collapse-tags": "",
                        clearable: "",
                        filterable: "",
                        multiple: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      on: {
                        change: _vm.changeSelect,
                        "remove-tag": _vm.removeTag
                      },
                      model: {
                        value: _vm.paramsData.server_ids,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "server_ids", $$v)
                        },
                        expression: "paramsData.server_ids"
                      }
                    },
                    [
                      _vm.serverList.length
                        ? _c("el-option", {
                            attrs: {
                              label: _vm.$t("selectAll"),
                              value: _vm.$t("selectAll")
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.selectAll($event)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._l(_vm.serverList, function(item) {
                        return _c(
                          "el-option",
                          {
                            key: item.serverID,
                            attrs: {
                              label: item.serverName,
                              value: item.serverID
                            }
                          },
                          [
                            _c("div", { staticClass: "serverOption" }, [
                              _c("div", [_vm._v(_vm._s(item.serverName))]),
                              _c("div", { staticStyle: { color: "red" } }, [
                                _vm._v(
                                  _vm._s(
                                    item.is_recomm == 1
                                      ? _vm.$t("recommend")
                                      : ""
                                  )
                                )
                              ])
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  key: "is_delay",
                  staticClass: "lodingItem",
                  attrs: { prop: "is_delay", label: _vm.$t("scheduledSend") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: {
                        placeholder: _vm.$t("pleaseSelectIsScheduledSend")
                      },
                      model: {
                        value: _vm.paramsData.is_delay,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "is_delay", $$v)
                        },
                        expression: "paramsData.is_delay"
                      }
                    },
                    _vm._l(_vm.delayList, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.paramsData.is_delay == 1
                ? _c(
                    "el-form-item",
                    {
                      key: "delay_time",
                      staticClass: "lodingItem",
                      attrs: {
                        prop: "delay_time",
                        label: _vm.$t("scheduledTime")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "popper-class": "no-atTheMoment",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("pleaseChoose"),
                          align: "right"
                        },
                        model: {
                          value: _vm.paramsData.delay_time,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "delay_time", $$v)
                          },
                          expression: "paramsData.delay_time"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.type == "limit"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { label: _vm.$t("level") }
                    },
                    [
                      _c(
                        "el-form-item",
                        { key: "maxlevel" },
                        [
                          _c("el-input", {
                            staticClass: "flex-1 no-number leftItem",
                            attrs: {
                              type: "number",
                              placeholder: _vm.$t("levelMax")
                            },
                            model: {
                              value: _vm.paramsData.level.maxlevel,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paramsData.level,
                                  "maxlevel",
                                  _vm._n($$v)
                                )
                              },
                              expression: "paramsData.level.maxlevel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { key: "minlevel" },
                        [
                          _c("el-input", {
                            staticClass: "flex-1 no-number ",
                            attrs: {
                              type: "number",
                              placeholder: _vm.$t("levelMin")
                            },
                            model: {
                              value: _vm.paramsData.level.minlevel,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paramsData.level,
                                  "minlevel",
                                  _vm._n($$v)
                                )
                              },
                              expression: "paramsData.level.minlevel"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.type == "limit"
                ? _c(
                    "el-form-item",
                    {
                      key: "sdk_type",
                      staticClass: "lodingItem",
                      attrs: { label: _vm.$t("channelId") }
                    },
                    [
                      _c("el-input", {
                        staticClass: "flex-1 no-number",
                        attrs: { placeholder: _vm.$t("multipleCommaSplit") },
                        model: {
                          value: _vm.paramsData.sdk_type,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "sdk_type", $$v)
                          },
                          expression: "paramsData.sdk_type"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.type == "limit"
                ? _c(
                    "el-form-item",
                    {
                      key: "channel_list",
                      staticClass: "lodingItem",
                      attrs: { label: _vm.$t("channelId") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "operationFrame-entity",
                          attrs: {
                            "collapse-tags": "",
                            multiple: "",
                            placeholder: _vm.$t("pleaseChoose")
                          },
                          on: { change: _vm.handleChannelChange },
                          model: {
                            value: _vm.paramsData.channel_list,
                            callback: function($$v) {
                              _vm.$set(_vm.paramsData, "channel_list", $$v)
                            },
                            expression: "paramsData.channel_list"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { "margin-left": "17px" },
                              on: { change: _vm.selectAllChannels },
                              model: {
                                value: _vm.channelChecked,
                                callback: function($$v) {
                                  _vm.channelChecked = $$v
                                },
                                expression: "channelChecked"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("selectAll")))]
                          ),
                          _vm._l(_vm.channellAllList, function(item) {
                            return _c("el-option", {
                              key: item.channel_mark,
                              attrs: {
                                label: item.channel_name,
                                value: item.channel_mark
                              }
                            })
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.type == "limit"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: { label: _vm.$t("vipLevel") }
                    },
                    [
                      _c(
                        "el-form-item",
                        { key: "maxviplevel" },
                        [
                          _c("el-input", {
                            staticClass: "flex-1 no-number leftItem",
                            attrs: {
                              type: "number",
                              placeholder: _vm.$t("levelMax")
                            },
                            model: {
                              value: _vm.paramsData.vip_level.maxviplevel,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paramsData.vip_level,
                                  "maxviplevel",
                                  _vm._n($$v)
                                )
                              },
                              expression: "paramsData.vip_level.maxviplevel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { key: "minviplevel" },
                        [
                          _c("el-input", {
                            staticClass: "flex-1 no-number",
                            attrs: {
                              type: "number",
                              placeholder: _vm.$t("levelMin")
                            },
                            model: {
                              value: _vm.paramsData.vip_level.minviplevel,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.paramsData.vip_level,
                                  "minviplevel",
                                  _vm._n($$v)
                                )
                              },
                              expression: "paramsData.vip_level.minviplevel"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.type == "limit"
                ? _c(
                    "el-form-item",
                    {
                      key: "maxlogouttime",
                      staticClass: "lodingItem",
                      attrs: { label: _vm.$t("timeMax") }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "popper-class": "no-atTheMoment",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("timeMax"),
                          align: "right"
                        },
                        model: {
                          value: _vm.paramsData.logout_time.maxlogouttime,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.paramsData.logout_time,
                              "maxlogouttime",
                              $$v
                            )
                          },
                          expression: "paramsData.logout_time.maxlogouttime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.type == "limit"
                ? _c(
                    "el-form-item",
                    {
                      key: "minlogouttime",
                      staticClass: "lodingItem",
                      attrs: { label: _vm.$t("timeMin") }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "popper-class": "no-atTheMoment",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          placeholder: _vm.$t("timeMin"),
                          align: "right"
                        },
                        model: {
                          value: _vm.paramsData.logout_time.minlogouttime,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.paramsData.logout_time,
                              "minlogouttime",
                              $$v
                            )
                          },
                          expression: "paramsData.logout_time.minlogouttime"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addDomain }
                    },
                    [_vm._v(_vm._s(_vm.$t("addItem")))]
                  )
                ],
                1
              ),
              _vm._l(_vm.paramsData.reward, function(domain, index) {
                return _c(
                  "div",
                  {
                    key: index + "r",
                    staticClass: "lodingItemT",
                    class: { "mobile-reward-item": _vm.isMobile },
                    staticStyle: { display: "flex" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "lodingItem-operationFrame flex",
                        class: { "mobile-reward-frame": _vm.isMobile }
                      },
                      [
                        _c("el-switch", {
                          staticStyle: {
                            "margin-right": "10px",
                            "min-width": "120px"
                          },
                          attrs: {
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                            "active-text": _vm.$t("permanent"),
                            "inactive-text": _vm.$t("valid")
                          },
                          model: {
                            value: domain.ispermanent,
                            callback: function($$v) {
                              _vm.$set(domain, "ispermanent", $$v)
                            },
                            expression: "domain.ispermanent"
                          }
                        }),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0px" },
                            attrs: {
                              prop: "reward." + index + ".type_id",
                              rules: domain.custom_input
                                ? []
                                : _vm.rules.item_id
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { "margin-right": "10px" },
                                attrs: {
                                  filterable: "",
                                  clearable: "",
                                  placeholder: _vm.$t("item"),
                                  disabled: !!domain.custom_input
                                },
                                model: {
                                  value: domain.type_id,
                                  callback: function($$v) {
                                    _vm.$set(domain, "type_id", $$v)
                                  },
                                  expression: "domain.type_id"
                                }
                              },
                              _vm._l(_vm.articleList, function(items, indexs) {
                                return _c("el-option", {
                                  key: indexs,
                                  attrs: { label: items.kind, value: items.id }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0px" },
                            attrs: {
                              prop: "reward." + index + ".custom_input",
                              rules: domain.type_id ? [] : _vm.rules.item_id
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("customItemIdPlaceholder"),
                                type: "number",
                                disabled: !!domain.type_id
                              },
                              model: {
                                value: domain.custom_input,
                                callback: function($$v) {
                                  _vm.$set(domain, "custom_input", $$v)
                                },
                                expression: "domain.custom_input"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0px" },
                            attrs: {
                              prop: "reward." + index + ".expire",
                              rules: domain.ispermanent
                                ? null
                                : _vm.rules.expire_time
                            }
                          },
                          [
                            _c("el-date-picker", {
                              staticStyle: {
                                width: "200px",
                                "margin-right": "10px"
                              },
                              attrs: {
                                "popper-class": "no-atTheMoment",
                                disabled: domain.ispermanent,
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                type: "datetime",
                                placeholder: _vm.$t("date")
                              },
                              model: {
                                value: domain.expire,
                                callback: function($$v) {
                                  _vm.$set(domain, "expire", $$v)
                                },
                                expression: "domain.expire"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0px" },
                            attrs: {
                              prop: "reward." + index + ".num",
                              rules: _vm.rules.item_num
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "number",
                                placeholder: _vm.$t("quantity")
                              },
                              model: {
                                value: domain.num,
                                callback: function($$v) {
                                  _vm.$set(domain, "num", _vm._n($$v))
                                },
                                expression: "domain.num"
                              }
                            })
                          ],
                          1
                        ),
                        _c("el-button", {
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            size: "mini",
                            type: "danger",
                            circle: "",
                            icon: "el-icon-delete"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.removeDomain(domain)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              }),
              _c(
                "div",
                {
                  staticClass: "flex",
                  class: { "mobile-content-moban": _vm.isMobile },
                  staticStyle: { width: "100%" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem ",
                      staticStyle: { width: "13%" },
                      attrs: { prop: "content_Val" }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            disabled: _vm.paramsData.template_type == 1
                          },
                          on: { click: _vm.addContent }
                        },
                        [_vm._v(_vm._s(_vm.$t("addContent")) + " ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem ",
                      staticStyle: { width: "40%", "margin-right": "40px" },
                      attrs: {
                        label: _vm.$t("isTemplate"),
                        "label-width": "100px"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "flex-1",
                          attrs: { placeholder: _vm.$t("pleaseChoose") },
                          on: { change: _vm.isTemplateChange },
                          model: {
                            value: _vm.isTemplate,
                            callback: function($$v) {
                              _vm.isTemplate = $$v
                            },
                            expression: "isTemplate"
                          }
                        },
                        _vm._l(_vm.moduleList, function(item) {
                          return _c("el-option", {
                            key: item.label,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.isTemplate == 1
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem ",
                          staticStyle: { width: "40%" },
                          attrs: {
                            label: _vm.$t("templateType"),
                            "label-width": "100px"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "flex-1",
                              attrs: { placeholder: _vm.$t("pleaseChoose") },
                              on: { change: _vm.templateTypeChange },
                              model: {
                                value: _vm.paramsData.template_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.paramsData, "template_type", $$v)
                                },
                                expression: "paramsData.template_type"
                              }
                            },
                            _vm._l(_vm.templateList, function(item) {
                              return _c("el-option", {
                                key: item.label,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._l(_vm.paramsData.content_Val, function(domain, index) {
                return _c(
                  "div",
                  { key: index + "k", staticClass: "content_ValClass" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "lodingItem-operationFrame flex",
                        staticStyle: { "margin-bottom": "20px" }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem contentValitem",
                            attrs: {
                              prop: "content_Val." + index + ".title",
                              rules: _vm.rules.title,
                              label: _vm.$t("title"),
                              "label-width": "60px"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "operationFrame-entity",
                              attrs: {
                                disabled: _vm.paramsData.template_type != 0,
                                clearable: "",
                                placeholder: _vm.$t("pleaseInputTitle")
                              },
                              model: {
                                value: domain.title,
                                callback: function($$v) {
                                  _vm.$set(domain, "title", $$v)
                                },
                                expression: "domain.title "
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "lodingItem contentValitem",
                            attrs: {
                              prop: "content_Val." + index + ".language",
                              rules: _vm.rules.language,
                              label: _vm.$t("language"),
                              "label-width": "60px"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "flex-1",
                                attrs: {
                                  disabled: _vm.paramsData.template_type != 0,
                                  clearable: "",
                                  filterable: "",
                                  placeholder: _vm.$t("pleaseChoose")
                                },
                                model: {
                                  value: domain.language,
                                  callback: function($$v) {
                                    _vm.$set(domain, "language", $$v)
                                  },
                                  expression: "domain.language "
                                }
                              },
                              _vm._l(_vm.langList, function(item) {
                                return _c("el-option", {
                                  key: item.label,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm.paramsData.template_type != 1
                          ? _c("el-button", {
                              staticStyle: { margin: "0 0 16px 10px" },
                              attrs: {
                                size: "mini",
                                type: "danger",
                                circle: "",
                                icon: "el-icon-delete"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.removeContent(domain)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex first_box lodingItem-title",
                        class: { "mobile-content-header": _vm.isMobile },
                        staticStyle: {
                          "margin-bottom": "20px",
                          width: "100%",
                          "align-items": "center"
                        }
                      },
                      [
                        _vm._v(_vm._s(_vm.$t("emailContent")) + ": "),
                        _vm.paramsData.template_type == 0
                          ? _c(
                              "div",
                              {
                                staticClass: "flex",
                                class: { "mobile-tag-list": _vm.isMobile },
                                staticStyle: { "padding-left": "20px" }
                              },
                              _vm._l(_vm.tagList, function(items, indexs) {
                                return _c(
                                  "div",
                                  {
                                    key: indexs,
                                    staticClass: "addtag",
                                    on: {
                                      click: function($event) {
                                        return _vm.addtag(items.content, index)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(items.name))]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          prop: "content_Val." + index + ".content",
                          rules: _vm.rules.content
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: { minRows: 2, maxRows: 12 },
                            disabled: _vm.paramsData.template_type != 0,
                            placeholder: _vm.$t("pleaseInputContent")
                          },
                          model: {
                            value: domain.content,
                            callback: function($$v) {
                              _vm.$set(domain, "content", $$v)
                            },
                            expression: "domain.content "
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.hiad()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("reset")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.reqLoading,
                    round: ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("saveDraft")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }